export default "__VITE_ASSET__DKd02YI7__"